<template>
	<div :class="{'row m-0' : small}">
		<div class="custom-control custom-checkbox remove-padding m-t-8"
		     :class="{'col-md-6 col-sm-6 col-6 p-0': small}"
		     v-for="checkbox in checkboxes.data" :key="checkbox.id">
			<div class="custom-control custom-switch">
				<input class="custom-control-input"
				       type="checkbox"
				       :id="checkbox.id"
				       :name="checkboxes.name"
				       :value="checkbox.value"
               :disabled="disabled"
				       :checked="checkbox.checked"
				       v-model="checked"
				/>
				<label class="custom-control-label label-checklist"
				       :for="checkbox.id"
				       :class="{'text-bold': checkbox.titleBold}"
				       v-html="checkbox.title"
				>
				</label>
			</div>
		</div>
	</div>
</template>

<script>
// checbox: {
// 	name: String,
// 	id: String,
// 	value: String,
// 	title: String,
// 	checked: Boolean,
// 	titleBold: Boolean,
// },

export default {
	name: "SOInputOnOff",
	props: {
      checkboxes : Object,
      small: Boolean,
      checked: Boolean,
      disabled: Boolean
  },
	// data() {
	// 	return {
	// 		selectedCheckbox: [],
	// 	}
	// },
	methods: {
		selected(obj) {
			this.$emit("selected", obj)
		}
	},
	watch: {
		// selectedCheckbox() {
		// 	this.$emit("selected", this.selectedCheckbox)
		// },
		checked: {
			handler: function () {
				this.$emit("selected", this.checked)
			},
			deep: true
		},
	}
}
</script>

<style scoped>
.text-bold {
	font-weight: bold;
}

.custom-control {
	padding-left: 0;
}
.custom-switch {
	padding-left: 1rem;
}
</style>